export type ParamsOption = {
    text: string;
    value: string;
}

export const dataVehicleType: Array<ParamsOption> = [
    {
        text: 'Passeio',
        value: 'passeio'
    },
    {
        text: 'Moto',
        value: 'moto'
    },
    {
        text: 'Caminhão',
        value: 'caminhao'
    },
    {
        text: 'Van',
        value: 'van'
    },
    {
        text: 'VUC',
        value: 'vuc'
    },
];

const dataCaminhaoComercialAtividades: Array<ParamsOption> = [
    {
        text: 'Transporte de alimentos(Carne, Aves, Pescados)',
        value: 'transporte_de_alimentos_carnes_aves_e_pescados'
    },
    {
        text: 'Transporte de alimentos (demais categorias exceto bebidas)',
        value: 'transporte_de_alimentos_exceto_carnes_aves_e_pescados_bebidas'
    },
    {
        text: 'Transporte de veículos (cegonha / guincho)',
        value: 'transporte_de_automovel_cegonheiro_guincho'
    },
    {
        text: 'Transporte de autopeças',
        value: 'transporte_de_autopecas'
    },
    {
        text: 'Transporte de bebidas (alcoólicas, refrigerantes, sucos)',
        value: 'transporte_de_bebida_alcoolica_refrigerante_suco'
    },
    {
        text: 'Transporte de brinquedos',
        value: 'transporte_de_brinquedo'
    },
    {
        text: 'Transporte de carga perigosa, combustível, tóxica ou corrosiva',
        value: 'transporte_de_carga_perigosa_combustivel_inflamavel_toxica_corrosiva'
    },
    {
        text: 'Transporte de carga viva / ração animal',
        value: 'transporte_de_carga_viva_racao_animal'
    },
    {
        text: 'Transporte de cigarros e fumo',
        value: 'transporte_de_cigarro_fumo'
    },
    {
        text: 'Transporte de supermercado: alimentos, higiene e limpeza',
        value: 'transporte_de_compras_de_supermercados_alimentos_higiene_limpeza'
    },
    {
        text: 'Transporte de eletrônicos (games, celular, TV, som, informática)',
        value: 'transporte_de_eletronico_game_celular_tv_som_computador_entre_outras'
    },
    {
        text: 'Transporte de produtos para jardinagem (flores, sementes, plantas, grama)',
        value: 'transporte_de_jardinagem_flores_sementes_plantas_grama_entre_outras'
    },
    {
        text: 'Transporte de lixo, esgoto, chorume, entulho, sucata',
        value: 'transporte_de_lixo_esgoto_chorume_entulho_sucata_entre_outras'
    },
    {
        text: 'Transporte de madeira, móveis e tapeçaria',
        value: 'transporte_de_madeira_moveis_tapecaria'
    },
    {
        text: 'Transporte de material bélico / armamento / explosivos',
        value: 'transporte_de_material_belico_armamento_substancia_explosiva_entre_outras'
    },
    {
        text: 'Transporte de material para construção (exceto obra civil)',
        value: 'transporte_de_material_para_construcao_exceto_construcao_civil'
    },
    {
        text: 'Transporte para construção civil / material de construção',
        value: 'transporte_de_material_para_construcao_civil_material_de_construcao'
    },
    {
        text: 'Transporte de medicamentos e farmácia',
        value: 'transporte_de_medicamento_farmaceutico'
    },
    {
        text: 'Transporte de mudanças',
        value: 'transporte_de_mudanca'
    },
    {
        text: 'Transporte de outras cargas (não especificadas)',
        value: 'transporte_de_outras_nao_especificadas'
    },
    {
        text: 'Transporte de pneus, câmara de ar, plástico / polietileno',
        value: 'transporte_de_pneu_camara_de_ar_plastico_polietileno'
    },
    {
        text: 'Transporte de produtos de higiene e limpeza',
        value: 'transporte_de_produtos_de_higiene_e_limpeza'
    },
    {
        text: 'Transporte de matéria-prima de metal (aço, alumínio, cobre, ferro)',
        value: 'transporte_de_materia_prima_de_metal_aco_aluminio_cobre_ferro'
    },
    {
        text: 'Autoescola',
        value: 'autoescola'
    },
    {
        text: 'Veículos Oficiais / Órgão Público',
        value: 'veiculos_oficiais_orgao_publico'
    },
    {
        text: 'Locadora / Test Drive',
        value: 'locadora_testdrive'
    },
    {
        text: 'Realiza serviço para transportadora',
        value: 'realiza_servico_para_transportadora'
    },
    {
        text: 'Não realiza serviço para transportadora',
        value: 'nao_realiza_servico_para_transportadora'
    },
    {
        text: 'Ambulância/Bombeiro/Competição/Vigilância',
        value: 'ambulancia_bombeiro_competicao_eventos_vigilancia'
    },
];

const dataMotoComercialAtividades: Array<ParamsOption> = [
    {
        text: 'Uso profissional (exceto frete ou entrega)',
        value: 'profissional_exceto_frete_entrega'
    },
    {
        text: 'Autoescola',
        value: 'autoescola'
    },
    {
        text: 'Veículos oficiais / órgão público',
        value: 'veiculos_oficiais_orgao_publico'
    },
    {
        text: 'Locadora / test-drive',
        value: 'locadora_testdrive'
    },
    {
        text: 'Ambulância, bombeiro, competição, eventos ou vigilância',
        value: 'ambulancia_bombeiro_competicao_eventos_vigilancia'
    },
];

const dataVanComercialAtividades: Array<ParamsOption> = [
    {
        text: 'Autoescola',
        value: 'autoescola'
    },
    {
        text: 'Uso profissional (exceto frete ou entrega)',
        value: 'profissional_exceto_frete_entrega'
    },
    {
        text: 'Veículos oficiais',
        value: 'veiculos_oficiais'
    },
    {
        text: 'Órgão público',
        value: 'orgao_publico'
    },
    {
        text: 'Transporte executivo',
        value: 'transporte_executivo'
    },
    {
        text: 'Turismo',
        value: 'turistico'
    },
    {
        text: 'Excursão',
        value: 'excursao'
    },
    {
        text: 'Transporte urbano, municipal ou intermunicipal',
        value: 'transporte_urbano_municipal_e_ou_intermunicipal'
    },
    {
        text: 'Transporte escolar',
        value: 'transporte_escolar'
    },
    {
        text: 'Locadora / test-drive',
        value: 'locadora_testdrive'
    },
    {
        text: 'Locadora / lotação / test-drive',
        value: 'locadora_lotacao_testdrive'
    },
    {
        text: 'Ambulância, bombeiro, competição, eventos ou vigilância',
        value: 'ambulancia_bombeiro_competicao_eventos_vigilancia'
    },
];

const dataVehicleUseByType: { [tipo: string]: Array<ParamsOption> } = {
    caminhao: [{ text: 'Particular', value: 'particular' }, { text: 'Comercial', value: 'comercial' }],
    moto: [{ text: 'Particular', value: 'particular' }, { text: 'Comercial', value: 'comercial' }, { text: 'Motorista de app', value: 'motorista_app' }, { text: 'Táxi', value: 'taxi' }],
    passeio: [{ text: 'Particular', value: 'particular' }, { text: 'Motorista de app', value: 'motorista_app' }, { text: 'Táxi', value: 'taxi' }, { text: 'Comercial', value: 'comercial' }],
    van: [{ text: 'Particular', value: 'particular' }, { text: 'Motorista de app', value: 'motorista_app' }, { text: 'Comercial', value: 'comercial' }, { text: 'Táxi', value: 'taxi' }],
    vuc: [{ text: 'Particular', value: 'particular' }, { text: 'Comercial', value: 'comercial' }],
};

const dataVehicleActivityByUse: { [chave: string]: Array<ParamsOption> } = {
    caminhao_comercial: dataCaminhaoComercialAtividades,
    caminhao_particular: [{ text: 'Lazer / Ida e volta ao trabalho', value: 'lazer_ida_e_volta_ao_trabalho' }],
    moto_comercial: dataMotoComercialAtividades,
    moto_motorista_app: [{ text: 'Entrega de mercadorias por app (frete)', value: 'entrega_de_mercadorias_frete_ubereats_ifood_loggi' }, { text: 'Mototáxi transporte de pessoas por app', value: 'mototaxi_transporte_de_pessoas_por_aplicativo' }],
    moto_particular: [{ text: 'Lazer / Ida e volta ao trabalho', value: 'lazer_ida_e_volta_ao_trabalho' }],
    moto_taxi: [{ text: 'Mototáxi transporte pessoas por app', value: 'mototaxi_transporte_de_pessoas_por_aplicativo' }],
    passeio_comercial: [{ text: 'Atividade profissional', value: 'comercial_atividade_profissional' }],
    passeio_motorista_app: [{ text: 'Transporte de pessoas e veículo de passeio', value: 'transporte_de_pessoas_veiculos_passeio' }, { text: 'Entrega de mercadorias por app (frete)', value: 'entrega_de_mercadorias_frete_ubereats_ifood_loggi' }],
    passeio_particular: [{ text: 'Lazer / Ida e volta ao trabalho', value: 'lazer_ida_e_volta_ao_trabalho' }],
    passeio_taxi: [{ text: 'Transporte de pessoas', value: 'transporte_de_pessoas' }],
    van_comercial: dataVanComercialAtividades,
    van_motorista_app: [{ text: 'Entrega de mercadorias por app (frete)', value: 'entrega_de_mercadorias_frete_ubereats_ifood_loggi_vans' }],
    van_particular: [{ text: 'Lazer / Ida e volta ao trabalho', value: 'lazer_ida_e_volta_ao_trabalho' }],
    van_taxi: [{ text: 'Táxi Van', value: 'taxi_van' }],
    vuc_comercial: dataCaminhaoComercialAtividades,
    vuc_particular: [{ text: 'Lazer / Ida e volta ao trabalho', value: 'lazer_ida_e_volta_ao_trabalho' }],
};

const dataPlatformTypeToVehicleType: { [codigo: string]: string } = {
    '1': 'passeio',
    '2': 'caminhao',
    '7': 'moto',
    '32': 'vuc',
};

export const getVehicleUseByType = (vehicleType: string): Array<ParamsOption> => {
    return dataVehicleUseByType[(vehicleType || '').toLowerCase()] || [];
}

export const getVehicleActivity = (vehicleType: string, vehicleUse: string): Array<ParamsOption> => {
    const tipo = (vehicleType || '').toLowerCase();
    const uso = (vehicleUse || '').toLowerCase();

    if (!tipo || !uso) {
        return [];
    }

    return dataVehicleActivityByUse[`${tipo}_${uso}`] || [];
}

export const isVehicleActivityRequired = (vehicleType: string, vehicleUse: string): boolean => {
    return getVehicleActivity(vehicleType, vehicleUse).length > 0;
}

export const getVehicleTypeByPlatformType = (cdTipoPlataforma?: number): string => {
    return dataPlatformTypeToVehicleType[`${cdTipoPlataforma}`] || '';
}

export const ParseVehicleType = (vehicleType: string): ParamsOption => {
    const tipo = (vehicleType || '').toLowerCase();

    return dataVehicleType.find((item) => item.value === tipo) || { text: '', value: '' };
}

export const ParseVehicleActivity = (vehicleType: string, vehicleUse: string, vehicleActivity: string): ParamsOption => {
    const atividade = (vehicleActivity || '').toLowerCase();

    return getVehicleActivity(vehicleType, vehicleUse).find((item) => item.value === atividade) || { text: '', value: '' };
}
